import { render, staticRenderFns } from "./SasvRegister.vue?vue&type=template&id=60b0385c"
import script from "./SasvRegister.vue?vue&type=script&lang=js"
export * from "./SasvRegister.vue?vue&type=script&lang=js"
import style0 from "./SasvRegister.vue?vue&type=style&index=0&id=60b0385c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports